module.exports = __webpack_public_path__ + "static/media/kyloren.1f091682.png";